module.exports = __webpack_public_path__ + "static/media/partner7.0c6bbad4.jpg";